import { useSelector } from 'react-redux';

const useGlobalError = () => {
  const {hasServerError} = useSelector(state => state.app);
  return hasServerError;
};

export default useGlobalError;
